import React, { useState } from "react";
import { Button, ButtonToolbar, Spinner } from "react-bootstrap";
import { CaretRightFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import OrderItem from "../../api/models/addOnTesting/ShoppingCart";
import FormatDate from "../../formatters/FormatDate";
import { PanelTable } from "./PanelTable";

interface TestsAvailableProps {
  items: OrderItem[]
  cartItems: OrderItem[]
  previousOrders: OrderItem[]
  onExpand: (item: OrderItem) => void
  onAddCart: (values: number[]) => void
  onNext: () => void
  processing: boolean
  processingOrders?: boolean
}

export const TestsAvailable = ({ items, cartItems, previousOrders, onExpand, onAddCart, onNext, processing, processingOrders }: TestsAvailableProps) => {
  const { t } = useTranslation()
  const [selectedPanels, setSelectedPanels] = useState<number[]>([])

  const add = () => {
    onAddCart(selectedPanels)
    setSelectedPanels([])
  }

  return <>
    {items.length === 0 && <p>{t('shoppingCart.noTestsAvailable')}</p>}
    {items.length === 0 && processingOrders && <p>{t('shoppingCart.processing')}</p>}
    {items.length !== 0 && <PanelTable items={items} onExpand={(item) => onExpand(item)} onSelect={(panels) => setSelectedPanels(panels)} selectedPanels={selectedPanels} />}
    <ButtonToolbar className="justify-content-between">
      <Button disabled={selectedPanels.length === 0 || processing} onClick={add} type="submit">{t('shoppingCart.addSelectedToCart')}</Button>
      <Button disabled={cartItems.length === 0 || processing} onClick={onNext}>
        {processing && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />}
        {t('shoppingCart.goToCart')}
      </Button>
    </ButtonToolbar>
    <div className="mt-3">
      {previousOrders.map(o => <div key={`panel-${o.addOnTestingPanelId}`} onClick={() => { onExpand(o) }}>
        <div className="d-flex align-items-center">
          <CaretRightFill className="text-primary" size={16} />
          <Button variant="link" className="text-decoration-none link-primary">
            {t('shoppingCart.previouslyOrderedAt', { name: o.name, date: FormatDate(o.createdAt) })}
          </Button>
        </div>
      </div>)}
    </div>
  </>
}